<template>
    <div>
        <div id="overlay-background" class="animate-hide" @click="close()"></div>
        <div id="overlay" class="animate-hide">
            <div id="player"></div>
            <span class="glyphicon glyphicon-remove icon-close" @click="close()"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ruth-overlay',
        props: ['close']
    }
</script>



// WEBPACK FOOTER //
// src/components/GlobalSegments/Overlay.vue